import React from "react";
import { Button, Alert, Divider } from "antd";
import { WindowsFilled, TeamOutlined, UserOutlined } from "@ant-design/icons";
import OAuth2Login from "react-simple-oauth2-login";
import { genVerifier, challenge } from "lib/pkce";

const handleRedirect = () => {
  localStorage.setItem("userAuthen", "QC");
  window.location.href = "/loginqc";
};

const onFailure = response => console.error(response);

const handleAzureLogin = async () => {
  const verifier = genVerifier();
  const codeChallenge = await challenge(verifier);
  sessionStorage.setItem("pkce_verifier", verifier);
  localStorage.setItem("userAuthen", "Azure");
  const clientId = process.env.REACT_APP_AZURE_CLIENT_ID;
  const params = new URLSearchParams({
    client_id: clientId,
    response_type: "code",
    redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    scope: `api://${clientId}/api.access`,
    code_challenge: codeChallenge,
    code_challenge_method: "S256",
  });
  window.location.href = `${process.env.REACT_APP_AZURE_AUTHORIZE_URI}?${params.toString()}`;
};

export default ({ auth, onSubmit: authFormSubmit }) => (
  <div>
    {auth.msg !== "" && (
      <Alert
        message={auth.msg}
        type={auth.status === "error" ? "error" : "warning"}
        showIcon
        closable
        style={{ marginBottom: "16px" }}
      />
    )}
    <Button
      type="primary"
      className="login-btn-primary"
      size="large"
      style={{
        width: "100%",
        borderRadius: "8px",
        height: "44px",
        fontWeight: 500,
        marginBottom: "10px",
      }}
      onClick={handleAzureLogin}
      icon={<WindowsFilled />}
    >
      {" "}พนักงานประจำ CPAC หรือ SCG
    </Button>
    <OAuth2Login
      authorizationUrl={process.env.REACT_APP_J2C_AUTHORIZE_URI}
      responseType="code"
      clientId={process.env.REACT_APP_J2C_CLIENT_ID}
      redirectUri={process.env.REACT_APP_REDIRECT_URI}
      onSuccess={response => {
        localStorage.setItem("userAuthen", "J2C");
        authFormSubmit({ ...response, type: "J2C" });
      }}
      onFailure={onFailure}
      render={v => (
        <Button
          type="primary"
          className="login-btn-contractor"
          size="large"
          style={{
            width: "100%",
            borderRadius: "8px",
            height: "44px",
            fontWeight: 500,
          }}
          onClick={v.onClick}
          icon={<TeamOutlined />}
        >
          {" "}พนักงานจ้างเหมา หรือ บุคคลภายนอก
        </Button>
      )}
    />
    <Divider style={{ color: "#bfbfbf", fontSize: "12px", margin: "16px 0" }}>หรือ</Divider>
    <Button
      size="large"
      onClick={handleRedirect}
      icon={<UserOutlined />}
      style={{
        width: "100%",
        borderRadius: "8px",
        height: "44px",
        color: "#dc2626",
        borderColor: "#dc2626",
      }}
    >
      บัญชีผู้ใช้งาน SmartQuality
    </Button>
  </div>
);
